export const KK7_BOUNDARY_AUDIT_PROJECT_ID = '1a816877-9baa-4997-bb84-d29d799e92ee';

export const KK7_BOUNDARY_RULE_SCORE = 0.6;

const KK7_NON_APPLICABLE_TRACK_IDS = new Set(['461a2b32-1fd9-4460-a655-0cc669a26698']);

export type Kk7BoundaryCohort = 'retained' | 'removed';

export interface Kk7BoundaryAuditTrack {
  readonly id: string;
  readonly title: string;
  readonly cohort: Kk7BoundaryCohort;
  readonly rank: number;
  readonly audioUrl: string;
  readonly impactScore: number;
}

export type Kk7BoundaryAuditFilter = 'all' | 'violates' | 'does-not-violate';
export type Kk7BoundaryAuditCohortFilter = 'all' | Kk7BoundaryCohort;

export function violatesKk7BoundaryRule(track: Kk7BoundaryAuditTrack) {
  return (
    !KK7_NON_APPLICABLE_TRACK_IDS.has(track.id) && track.impactScore >= KK7_BOUNDARY_RULE_SCORE
  );
}

export function filterKk7BoundaryAuditTracks(
  tracks: readonly Kk7BoundaryAuditTrack[],
  options: {
    readonly filter: Kk7BoundaryAuditFilter;
    readonly cohort: Kk7BoundaryAuditCohortFilter;
    readonly query: string;
  },
) {
  const normalizedQuery = options.query.trim().toLocaleLowerCase();
  return tracks.filter((track) => {
    if (options.cohort !== 'all' && track.cohort !== options.cohort) return false;
    if (normalizedQuery && !track.title.toLocaleLowerCase().includes(normalizedQuery)) return false;
    const violates = violatesKk7BoundaryRule(track);
    if (options.filter === 'violates') return violates;
    if (options.filter === 'does-not-violate') return !violates;
    return true;
  });
}
